import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import './ProductDetailSkeleton.css'

const ProductDetailSkeleton = () => {
  return (
    <>
    <div className='skeleton-product-detail-container'>
        <div className='skeleton-product-info-container'>
          <div className='skeleton-product-thumnails'>
            <div className='skeleton-product-image-selector'>
               {[1, 2, 3, 4].map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rectangular"
                  width={'100%'}
                  height={'6.5vmax'}
                  animation="wave"
                />
              ))}
            </div>
            <div className='skeleton-product-main-thumnail'>
              <Skeleton variant="rectangular" width="100%" height={'40vmax'} animation="wave" />
            </div>
          </div>
          <div className='skeleton-product-info'>
          <Skeleton variant="text" width="100%" height={40} animation="wave" />
          <Skeleton variant="text" width="90%" height={30} animation="wave" />
          <Skeleton variant="text" width="80%" height={30} animation="wave" className='skeleton-product-name'/>
          <div className='skeleton-stock'>
          <Skeleton variant="text" width="4%" height={30} animation="wave" />
          <Skeleton variant="text" width="15%" height={30} animation="wave" />
          </div>
          {[1, 2, 3].map((_, index) => (
                <Skeleton
                  key={index}
                  variant="rectangular"
                  width={'100%'}
                  height={60}
                  animation="wave"
                  className='skeleton-btn'
                />
              ))}
          </div>
        </div>
        <div className='skeleton-product-description'>
        <Skeleton variant="text" width="15%" height={35} animation="wave" />
        {[1, 2, 3 ].map((_, index) => (
                <Skeleton
                  key={index}
                  variant="text"
                  width={'100%'}
                  height={35}
                  animation="wave"
                />
              ))}
        <Skeleton variant="text" width="80%" height={35} animation="wave" />
        </div>
        <div className="description-product-image-container" style={{marginTop:'3rem'}}>
          {[1, 2, 3, 4].map((_, index) => (
            <Skeleton
              key={index}
              variant="rectangular"
              width={'100%'}
              height={'40vmax'}
              animation="wave"
              style={{ borderRadius: '8px', marginRight: '10px' }}
            />
          ))}
        </div>
        <div className='skeleton-product-video' style={{marginTop:'3rem'}}>
          <Skeleton variant="rectangular" width="100%" height={'45vmax'} animation="wave" />
        </div>
        {/* -----------Draw Text 2 Sided line code--------------- */}
        <div className="text-container">
          <Skeleton variant="text" width="100%" height={10} animation="wave" />
        </div>
        {/* -----------Draw Text 2 Sided line code-------------- */}

        {/* ------------------"You May Also Like" section----------------- */}
        <div style={{ display: 'flex', gap: '2rem', marginTop: '20px', overflow:'hidden' }}>
          {[1, 2, 3, 4,5 ].map((_, index) => (
            <div key={index} className="SuggestionsCard">
              <Skeleton
                variant="rectangular"
                width={200}
                height={200}
                animation="wave"
                style={{ borderRadius: '8px' }}
              />
              <Skeleton variant="text" width="80%" height={20} animation="wave" />
              <Skeleton variant="text" width="60%" height={20} animation="wave" />
              <Skeleton variant="rectangular" width={'100%'} height={30} animation="wave" />
            </div>
          ))}
        </div>
        <Skeleton variant="rectangular" width="100%" height={250} animation="wave" style={{ marginTop: '3rem' }} />

    </div>
    </>
  );
};

export default ProductDetailSkeleton;